var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 314,
    viewBox: "0 0 251 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.667 0H17.3328C7.7558 0 0 7.7558 0 17.3328V296.667C0 306.244 7.7558 314 17.3328 314H167.707V192.404H126.793V145.021H167.707V110.057C167.707 69.4882 192.482 47.414 228.67 47.414C246.003 47.414 260.887 48.7014 265.236 49.2823V91.6723H240.147C220.459 91.6723 216.66 101.029 216.66 114.751V145.005H263.587L257.464 192.388H216.644V314H296.667C306.244 314 314 306.244 314 296.667V17.3328C314 7.7558 306.244 0 296.667 0Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityGroup3);
export default __webpack_public_path__ + "static/media/communityGroup3.fcfecfbd166dc134db07d4c0b2a34f5d.svg";
export { ForwardRef as ReactComponent };